import { render, staticRenderFns } from "./VideoFromReference.vue?vue&type=template&id=5708bca6&scoped=true"
import script from "./VideoFromReference.vue?vue&type=script&lang=js"
export * from "./VideoFromReference.vue?vue&type=script&lang=js"
import style0 from "./VideoFromReference.vue?vue&type=style&index=0&id=5708bca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5708bca6",
  null
  
)

export default component.exports